<div class="card">
  <div class="card-body">
    <app-line-chart [series]="series" [enableDatawrapper]="true"></app-line-chart>
  </div>
</div>
